import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Printer, ArrowLeft, Loader } from "lucide-react";
import ProcurementInvoice from "../components/inventory/ProcurementInvoice";
import * as inventoryService from "../api/inventoryService";

export default function NotaPO() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await inventoryService.getPurchaseOrderDetail(id);
        const detailData = response?.data || response;
        if (!active) return;
        setData(detailData || null);
      } catch (err) {
        if (!active) return;
        setError(err?.message || "Gagal memuat data");
      } finally {
        if (!active) return;
        setLoading(false);
      }
    };

    if (id) load();

    return () => {
      active = false;
    };
  }, [id]);

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/inventori/purchase-orders");
    }
  };

  return (
    <div className="min-h-screen bg-slate-100/80 py-0 print:bg-white print:p-0">
      <style>{`
        @media print {
          .no-print { display: none !important; }
          @page {
            size: 210mm 148mm;
            margin: 4mm 6mm;
          }
          html, body {
            width: 210mm !important;
            height: 148mm !important;
            background: white !important;
            margin: 0 !important;
            padding: 0 !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        }
      `}</style>
      
      {/* Sticky Top Navigation Bar */}
      <div className="no-print sticky top-0 z-10 bg-white/95 backdrop-blur-sm border-b border-slate-200 px-6 py-3.5 flex items-center justify-between shadow-xs">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={handleBack}
            className="px-3 py-1.5 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 hover:text-slate-900 transition-colors flex items-center gap-1.5 text-xs font-semibold shadow-2xs"
            title="Kembali">
            <ArrowLeft className="w-4 h-4 text-slate-600" />
            <span>Kembali</span>
          </button>
          <div className="h-4 w-px bg-slate-200"></div>
          <div className="text-sm font-bold text-slate-800 tracking-tight flex items-center gap-2">
            <span>Nota Purchase Order</span>
            {data?.po_number && (
              <span className="text-xs font-bold px-2 py-0.5 rounded-md bg-teal-50 text-teal-700 border border-teal-200 font-mono">
                {data.po_number}
              </span>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2.5">
          <button
            type="button"
            onClick={() => window.print()}
            className="px-4 py-2 rounded-xl bg-teal-600 text-white text-xs font-bold hover:bg-teal-700 shadow-sm shadow-teal-600/20 transition-all flex items-center gap-1.5">
            <Printer className="w-4 h-4" />
            <span>Cetak Nota</span>
          </button>
        </div>
      </div>

      {/* Main Invoice Container */}
      <div className="p-4 sm:p-8 print:p-0 flex justify-center">
        {loading ? (
          <div className="flex items-center gap-2 text-slate-500 text-sm py-16">
            <Loader className="w-5 h-5 animate-spin text-teal-600" />
            <span>Memuat data Purchase Order...</span>
          </div>
        ) : error ? (
          <div className="p-6 bg-white rounded-2xl border border-rose-200 text-rose-600 text-sm max-w-md text-center my-12">
            {error}
          </div>
        ) : (
          <ProcurementInvoice data={data} />
        )}
      </div>
    </div>
  );
}
